var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.714 15c.395 0 .715.32.715.714 0 .395-.32.715-.715.715H9.286c-.395 0-.715-.32-.715-.715 0-.394.32-.714.715-.714h1.428zM10 2.857c1.974 0 3.373.82 4.205 2.2.55.912.795 1.989.795 2.8v3.355l.01.016.584.876.715 1.071c.316.475-.024 1.11-.595 1.11H4.286c-.57 0-.911-.635-.595-1.11L5 11.212V7.857c0-.811.245-1.888.795-2.8.832-1.38 2.23-2.2 4.205-2.2z",
    transform: "translate(-1131 -25) translate(1116 10) translate(15 15)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8ebc2cf8a6052466c4be86c05d181ddd.svg";
export { ForwardRef as ReactComponent };